import { BaseService } from '../../infra/base.service'
import type { BillEntity } from './bill'
import type { BillsRepository } from './bills.repository'
import type { PayBillDto } from './dto/pay-bill.dto'

export class BillsService extends BaseService<BillEntity> {
    constructor(private rep: BillsRepository) {
        super(rep)
    }

    async pay(billId: string, dto: PayBillDto) {
        return this.rep.pay(billId, dto)
    }

    async void(billId: string) {
        return this.rep.void(billId)
    }
}
